import { getDisplayName } from 'core/person';
import {
  DeviceApi,
  OrganizationApi,
  PatientApi,
  PractitionerApi,
} from 'integration/aggregate';

const practitionerApi = new PractitionerApi();
const deviceApi = new DeviceApi();
const patientApi = new PatientApi();
const organizationApi = new OrganizationApi();

export type Fetcher = (id: string) => Promise<string | undefined>;

export type SupportedResource =
  | 'Practitioner'
  | 'Patient'
  | 'Device'
  | 'Organization';

export const fetchers: Record<SupportedResource, Fetcher> = {
  Practitioner: (id: string) =>
    practitionerApi
      .getPractitioner(id)
      .then((value) => getDisplayName(value.general)),
  Device: (id: string) => deviceApi.getDevice(id).then((value) => value?.name),
  Patient: (id: string) =>
    patientApi.getPatient(id).then((value) => getDisplayName(value.general)),
  Organization: (id: string) =>
    organizationApi.getOrganization(id).then((org) => org.general.name),
};

export type LinkTo = {
  pathname: string;
  params?: Record<string, string>;
};

export const linkMap: Record<SupportedResource, (id: string) => LinkTo> = {
  Patient: (id) => ({
    pathname: `/patient/${id}/profile`,
  }),
  Device: (id) => ({
    pathname: `/admin/device/${id}`,
  }),
  Practitioner: (id) => ({
    pathname: `/admin/practitioner/${id}`,
  }),
  Organization: (id) => ({
    pathname: `/admin/organization/${id}`,
  }),
};
